import React, { useEffect } from "react";
import { Footer } from "../../Components/Footer/Footer";
import { Header } from "../../Components/Header/Header";
import { PageHeader } from "../../Components/PageHeader/PageHeader";
import SeoDefault from "../../Components/Seo/SeoDefault";
import { useApp } from "../../context/AppContextProvider";
import SidebarContentLayout from "../../Components/SidebarContentLayout/SidebarContentLayout";

export const Faq = () => {
  const appData = useApp();
  let windowWidth = appData.appData.windowWidth;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const faqContent = {
    title: "Frequently Asked Questions (FAQ) - Ashi Electronics",
    effectiveDate: "2025-01-01",
    sections: [
      {
        id: "about-ashi",
        title: "1. About Ashi Electronics",
        content: [
          "<h5><b style='color: gray;'>1.1 Who is Ashi Electronics?</b></h5>",
          "<p>Ashi Electronics is a leading provider of high-quality open-box home appliances and electronics. We offer premium products at competitive prices, ensuring that each item undergoes strict inspection and quality checks before sale. Our goal is to make advanced technology accessible to a wider audience while providing cost-effective solutions without compromising on performance.</p>",

          "<h5><b  style='color: gray;'>1.2 Where is Ashi Electronics located?</b></h5>",
          "<p>Our retail store is located in <b>Sector 17, Sukhrali, Gurgaon, Haryana</b>. We welcome you to visit us to explore our product range in person.</p>",

          "<h5><b  style='color: gray;'>1.3 Is Ashi Electronics a legally registered and recognized business?</b></h5>",
          "<p>Yes, Ashi Electronics is a <b>legally registered</b> and <b>recognized company</b> in the consumer electronics industry. We adhere to all regulatory requirements and industry standards, ensuring transparency, reliability, and customer trust. Our commitment to quality products and exceptional service has established us as a trusted name in the market.</p>"
        ]
      },
      {
        id: "product-info",
        title: "2. Product Information",
        content: [
          "<h5><b  style='color: gray;'>2.1 What is an open-box product?</b></h5>",
          "<p>An open-box product is an item that has been returned by a customer, often due to a change of mind or minor cosmetic imperfections on the packaging. These products are thoroughly tested and inspected to ensure they function as intended before being resold.</p>",

          "<h5><b style='color: gray;'>2.2 What types of products does Ashi Electronics offer?</b></h5>",
          "<p>We specialize in a variety of open-box home appliances and electronics, including:</p>",
          "<ul>",
          "<li>Refrigerators</li>",
          "<li>Air conditioners</li>",
          "<li>Washing machines</li>",
          "<li>Microwaves and more</li>",
          "</ul>",
          "<p>All products undergo rigorous testing to meet high-quality standards.</p>",

          "<h5><b style='color: gray;'>2.3 Are the products you sell brand new?</b></h5>",
          "<p>Although our products are open-box, they are either unused or have been gently used and fully refurbished. We ensure each item is thoroughly inspected and tested to deliver the same high performance as new products, offering excellent value for money.</p>",

          "<h5><b style='color: gray;'>2.4 Are open-box products covered under warranty?</b></h5>",
          "<p>Yes, all our open-box products come with a warranty. The specific warranty period and terms are listed on each product page. We stand behind the quality of our products and strive to provide you with a worry-free shopping experience.</p>"
        ]
      },
      {
        id: "ordering-payment",
        title: "3. Ordering & Payment",
        content: [
          "<h5><b style='color: gray;'>3.1 How do I place an order on your website?</b></h5>",
          "<p>To place an order, simply browse our catalog on <a href='https://www.ashielectronics.com'>www.ashielectronics.com</a>, select the items you wish to purchase, and add them to your cart. Proceed to checkout, where you'll enter your shipping and payment details to complete your transaction securely.</p>",

          "<h5><b style='color: gray;'>3.2 What payment methods do you accept?</b></h5>",
          "<p>We accept a variety of secure payment methods, including:</p>",
          "<ul>",
          "<li>Major <b>credit/debit cards</b></li>",
          "<li><b>EMI options</b></li>",
          "<li><b>Online payment gateways</b></li>",
          "</ul>",
          "<p>All transactions are encrypted to protect your personal information.</p>",

          "<h5><b style='color: gray;'>3.3 Is my personal information safe when shopping with you?</b></h5>",
          "<p>Yes, your privacy and security are of utmost importance to us. We use <b>SSL encryption</b> to protect your personal and payment information during transactions. Your data is stored securely and is never shared with third parties without your consent.</p>"
        ]
      },
      {
        id: "shipping-delivery",
        title: "4. Shipping & Delivery",
        content: [
          "<h5><b style='color: gray;'>4.1 How long does it take to receive my order?</b></h5>",
          "<p>Orders typically arrive within <b>0-7 business days</b> for standard delivery. Delivery time may vary based on product availability and your location. For example <b>Gurugram and NCR customers</b> may get the same delivery.</p>",

          "<h5><b style='color: gray;'>4.2 How can I track my order?</b></h5>",
          "<p>Once your order has been shipped, you will receive an email with a <b>tracking number</b> and a link to monitor your shipment in real time.</p>"
        ]
      },
      {
        id: "returns-refunds",
        title: "5. Cancellations, Returns & Refunds",
        content: [
          "<h5><b style='color: gray;'>5.1 How do I cancel my order?</b></h5>",
          "<p>You can cancel your order before it is shipped by contacting our customer service team. If the order has already been shipped, you may need to follow our return process after the product is delivered.</p>",

          "<h5><b style='color: gray;'>5.2 What should I do if I receive a defective or damaged product?</b></h5>",
          "<p>We request that you inspect the product and its accessories carefully upon delivery. Please make a complete unboxing video without any breaks. If the item is defective or damaged, contact our customer support team immediately within <b>24 hours</b> of receiving the product. We will guide you through the return process and arrange a <b>replacement</b> or <b>refund</b> in accordance with our policy.</p>",

          "<h5><b style='color: gray;'>5.3 Can I return or exchange an open-box product?</b></h5>",
          "<p>Yes, we offer a hassle-free return and exchange policy for open-box products. If you're not satisfied with your purchase, please refer to our Return Policy for detailed instructions on initiating a return or exchange.</p>",

          "<h5><b style='color: gray;'>5.4 How long does it take to process a refund?</b></h5>",
          "<p>Refunds are typically processed within <b>7-10 business days</b> after the returned product is received and inspected. The refund will be credited to the same <b>payment method</b> used for the purchase.</p>"
        ]
      },
      {
        id: "customer-support",
        title: "6. Customer Support",
        content: [
          "<h5><b style='color: gray;'>6.1 How can I contact customer support?</b></h5>",
          "<p>Our dedicated customer support team is available to assist you. You can reach us through:</p>",
          "<ul>",
          "<li>Email: <a href='mailto:hello@ashielectronics.com'>hello@ashielectronics.com</a></li>",
          "<li>Phone: <a href='tel:+919654502991'>+91 9654502991</a> (During business hours)</li>",
          "<li>Live Chat: Available on our website for real-time assistance.</li>",
          "</ul>"
        ]
      },
      {
        id: "privacy-security",
        title: "7. Privacy & Security",
        content: [
          "<h5><b style='color: gray;'>7.1 Do you store payment details?</b></h5>",
          "<p>We do not store your payment details. All transactions are processed through secure third-party payment gateways to ensure your information is protected.</p>"
        ]
      },
      {
        id: "installation",
        title: "8. Installation Services",
        content: [
          "<h5><b style='color: gray;'>8.1 Do you offer installation services for the products you sell?</b></h5>",
          "<p>For certain products, such as refrigerators, washing machines, and air conditioners, we offer <b>installation services</b>. Please check the product page for installation availability. If the service is available, it will be coordinated by our trusted installation partners.</p>"
        ]
      },
      {
        id: "discounts-promotions",
        title: "9. Discounts & Promotions",
        content: [
          "<h5><b style='color: gray;'>9.1 Do you offer any discounts or promotions?</b></h5>",
          "<p>Ashi Electronics accepts the following payment methods:</p>",
          "<ul>",
          "<li>Major <b>credit/debit cards</b></li>",
          "<li><b>EMI options</b></li>",
          "<li><b>Online payment gateways</b></li>",
          "</ul>",
          "<p>Yes, from time to time, we run special offers and promotions on our products. Be sure to subscribe to our newsletter or check our website for the latest deals and discounts.</p>",

          "<h5><b style='color: gray;'>9.2 How do I apply a discount or promo code?</b></h5>",
          "<p>If you have a valid promo code, you can enter it during the checkout process to receive your discount. Make sure to apply the code before finalizing the payment.</p>"
        ]
      },
      {
        id: "product-availability",
        title: "10. Product Availability & Restocking",
        content: [
          "<h5><b style='color: gray;'>10.1 What happens if the product I want is out of stock?</b></h5>",
          "<p>If the product you're interested in is out of stock, you can <b>sign up for notifications</b> on the product page. We'll notify you as soon as the item is back in stock.</p>",

          "<h5><b style='color: gray;'>10.2 How do I know when a product is available again?</b></h5>",
          "<p>Our website will display the product's availability status. You can also sign up for <b>restock alerts</b> to receive an email when the item becomes available again.</p>"
        ]
      },
      {
        id: "customer-reviews",
        title: "11. Customer Reviews & Feedback",
        content: [
          "<h5><b style='color: gray;'>11.1 Can I leave a review for a product I purchased?</b></h5>",
          "<p>Yes, we encourage customers to leave reviews and feedback on the products they purchase. Your review helps other customers make informed decisions and allows us to improve our offerings.</p>",

          "<h5><b style='color: gray;'>11.2 How do I leave a review?</b></h5>",
          "<p>After purchasing a product, you can visit the product page and leave your feedback by filling out the review section. You may include a star rating and comments based on your experience.</p>"
        ]
      }
    ]
  };

  return (
    <React.Fragment>
      <SeoDefault
        title="FAQ - Ashi Electronics"
        description="Find answers to frequently asked questions about shopping at Ashi Electronics for electronics and household items."
        keywords="Ashi Electronics FAQ, electronics store questions, customer support India"
        canonicalUrl={`${process.env.REACT_APP_URL}/faq`}
        pageType="website"
        breadcrumbItems={[
          { name: "Home", url: `${process.env.REACT_APP_URL}/` },
          { name: "FAQ", url: `${process.env.REACT_APP_URL}/faq` },
        ]}
      />
      {windowWidth === "mobile" ? (
        <PageHeader title="FAQ" hide={true} />
      ) : (
        <Header />
      )}
      <section className="section col-md-12">
        <div className="container">
          <SidebarContentLayout contentData={faqContent} />
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
};
